import { clsx } from 'clsx'

import { pageHeaderStyles, Separator } from '@buffer-mono/popcorn'

import { ViewOnlyPublishCoachMark } from '~publish/components/ViewOnlyCoachMarks'
import type { ViewOnlyCopy } from '~publish/components/ViewOnlyCoachMarks'

import { ViewOnlyBadge } from './ViewOnlyBadge'

import styles from './ViewOnlyHeaderBadge.module.css'

import type { JSX } from 'react'

/**
 * "View only" badge with a trailing separator for Publish page headers. The
 * separator hides on narrow headers, where every control after the badge is
 * hidden too and it would otherwise dangle at the row end.
 */
export const ViewOnlyHeaderBadge = ({
  copy,
}: {
  /** What view-only means on the badged surface. Defaults to Publish. */
  copy?: ViewOnlyCopy
}): JSX.Element => (
  <>
    <ViewOnlyPublishCoachMark copy={copy}>
      <ViewOnlyBadge />
    </ViewOnlyPublishCoachMark>
    <Separator
      orientation="vertical"
      decorative
      data-testid="view-only-header-separator"
      className={clsx(styles.separator, pageHeaderStyles.hideOnNarrow)}
    />
  </>
)
